import script from "./ProjectStatusTransitionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectStatusTransitionModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectStatusTransitionModal.vue?vue&type=style&index=0&id=501b7fca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501b7fca"]])

export default __exports__